import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Banco de 100 Ejercicios',
    desc: '100+ ejercicios por técnica, nivel y objetivo. Explicados paso a paso.',
    value: 'USD 8.00'
  }, {
    num: '02',
    title: 'Juegos y Dinámicas Grupales',
    desc: '50 juegos y dinámicas para asegurar el engagement y la retención de alumnos.',
    value: 'USD 10.00'
  }, {
    num: '03',
    title: 'Sistema de Evaluación',
    desc: 'Fichas, rúbricas, seguimiento mensual y reportes de progreso listos.',
    value: 'USD 7.00'
  }, {
    num: '04',
    title: 'Preparación Física para Vóley',
    desc: 'Salto, velocidad, prevención de lesiones y rutinas de 4 a 8 semanas.',
    value: 'USD 6.00'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-dark border-y border-white/5" data-id="element-23">
      <div className="max-w-4xl mx-auto" data-id="element-24">
        <div className="text-center mb-5" data-id="element-25">
          <div className="inline-flex items-center justify-center bg-brand-accent text-brand-dark font-black px-3 py-1 rounded-full mb-2 text-[10px] shadow-[0_0_15px_rgba(0,191,255,0.3)] tracking-wider" data-id="element-26">
            <Gift className="w-3 h-3 mr-1.5" data-id="element-27" />
            Incluidos en las 2 ofertas — sin costo extra
          </div>
          <h2 className="text-lg md:text-2xl font-black text-white" data-id="element-28">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-5" data-id="element-29">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-lg p-4 border border-white/5 hover:border-brand-accent/40 transition-colors" data-id="element-30">
              <div className="flex items-start mb-2" data-id="element-31">
                <div className="bg-brand-accent text-brand-dark font-black text-xs w-7 h-7 rounded-lg flex items-center justify-center mr-2.5 shrink-0" data-id="element-32">
                  {bonus.num}
                </div>
                <div className="flex-1" data-id="element-33">
                  <h3 className="text-sm font-black leading-tight text-white mb-0.5" data-id="element-34">
                    {bonus.title}
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400 leading-relaxed font-medium" data-id="element-35">
                    {bonus.desc}
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between border-t border-white/10 pt-2 mt-2" data-id="element-36">
                <span className="text-gray-600 line-through font-bold text-xs" data-id="element-37">
                  {bonus.value}
                </span>
                <span className="text-brand-dark font-black text-[10px] bg-brand-accent px-2 py-0.5 rounded" data-id="element-38">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-lg p-3 text-center border border-brand-accent/30 max-w-md mx-auto" data-id="element-39">
          <p className="text-xs font-bold text-gray-400" data-id="element-40">
            Valor total de los 4 bonos:{' '}
            <span className="line-through text-gray-600" data-id="element-41">USD 31.00</span>{' '}
            <span className="text-brand-accent font-black neon-glow" data-id="element-42">
              → GRATIS
            </span>
          </p>
          <p className="text-[9px] text-gray-500 font-medium mt-0.5" data-id="element-43">
            Solo en este lanzamiento. Incluidos en las 2 ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}